import { matchPath } from 'react-router-dom';

import {
  HIDDEN_HEADER_ROUTES,
  HIDDEN_FOOTER_ROUTES,
  HIDDEN_USER_AGREEMENT_MODAL_ROUTES,
  NO_PADDING_ROUTES,
  DAILY_ENERGY_ROUTES,
  HEADER_COOKIE_BALANCE_ID,
} from '@app/shared/constants/layout';

export const matchesAnyRoute = (routes: string[], location: string) =>
  routes.some((route) => matchPath(route, location));

export const showHeader = (location: string) => !matchesAnyRoute(HIDDEN_HEADER_ROUTES, location);

export const showFooter = (location: string) => !matchesAnyRoute(HIDDEN_FOOTER_ROUTES, location);

export const showUserAgreementModal = (location: string) =>
  !matchesAnyRoute(HIDDEN_USER_AGREEMENT_MODAL_ROUTES, location);

export const includePadding = (location: string) => !matchesAnyRoute(NO_PADDING_ROUTES, location);

export const isDailyEnergyRoute = (location: string) =>
  matchesAnyRoute(DAILY_ENERGY_ROUTES, location);

export const getHeaderCookieBalanceElementRect = () => {
  const element = document.getElementById(HEADER_COOKIE_BALANCE_ID);
  return element?.getBoundingClientRect();
};
